import { createContext, useContext, useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { applyTheme, readThemePreference, THEME_KEY } from './appTheme';
import './appTheme.css';

const AppearanceContext = createContext(null);

export default function AppAppearance({ children }) {
  const [preference, setPreference] = useState(readThemePreference);
  useEffect(() => {
    const update = () => {
      const mode = applyTheme(preference);
      if (Capacitor.isNativePlatform()) {
        StatusBar.setStyle({ style: mode === 'light' ? Style.Light : Style.Dark }).catch(() => {});
        StatusBar.setBackgroundColor({ color: mode === 'light' ? '#F3F5F7' : '#101820' }).catch(() => {});
      }
    };
    update();
    const media = window.matchMedia?.('(prefers-color-scheme: dark)');
    media?.addEventListener?.('change', update);
    return () => media?.removeEventListener?.('change', update);
  }, [preference]);
  useEffect(() => {
    const changed = (e) => { if (e.key === THEME_KEY) setPreference(readThemePreference()); };
    window.addEventListener('storage', changed);
    return () => window.removeEventListener('storage', changed);
  }, []);
  const changePreference = (value) => {
    try { localStorage.setItem(THEME_KEY, value); } catch { /* Still works for this session. */ }
    setPreference(value);
  };
  return <AppearanceContext.Provider value={{ preference, changePreference }}>
    {children === undefined ? <AppearanceSelector /> : children}
  </AppearanceContext.Provider>;
}

export function AppearanceSelector() {
  const appearance = useContext(AppearanceContext);
  if (!appearance) return null;
  return <label className="app-appearance" title="Appearance">
    <select aria-label="App appearance" value={appearance.preference} onChange={(e) => appearance.changePreference(e.target.value)}>
      <option value="light">☀ Light</option><option value="dark">☾ Dark</option><option value="system">System</option>
    </select>
  </label>;
}
